import { useReactDndConstructs as useDragAndDropHooks } from '../../../../dnd/ReactDndContext';
import { DragPreview } from '../../../../dnd/view/DragPreview';
import { useDesignTokens } from '../../../../theme';
import { getTabBarDesignTokens } from '../BaseTabBar';
import { TabBarVariant } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
export const TabDragPreview = props => {
  const {
    useDragLayer
  } = useDragAndDropHooks();
  const {
    itemType,
    item
  } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType()
  }));
  const dt = useDesignTokens();
  const tokens = getTabBarDesignTokens(dt, {
    alternate: false,
    variant: TabBarVariant.Standard
  });
  const renderItem = () => {
    if (!item || item.dndPrefix !== props.dndPrefix) return null;
    switch (itemType) {
      case props.dragType:
        return props.children(item.index);
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsx(DragPreview, {
    style: tokens,
    children: renderItem()
  });
};
//# sourceMappingURL=TabDragPreview.js.map